import React from 'react';
import PropTypes from 'prop-types';
import ReactCSSTransitionGroup from 'react-addons-css-transition-group';
import Credits from '../components/Credits';
import QuestionIntro from '../components/QuestionIntro';
import SubQuestion from '../components/SubQuestion';
import AnswerOption from '../components/AnswerOption';
import logotagline from '../images/logo-tagline.png' // relative path to image

const propTypes = {
  userAnswers: PropTypes.array.isRequired,
  answerOptions: PropTypes.array.isRequired,
  questionIntro: PropTypes.string.isRequired,
  questionType: PropTypes.string.isRequired,
  onAnswerSelected: PropTypes.func.isRequired,
  onClickContinue: PropTypes.func.isRequired,
  disableContinue: PropTypes.bool.isRequired
};

function Quiz(props) {

  function renderAnswerOption(subQuestionNumber, answerOption) {
    return (
      <AnswerOption
        key={String(subQuestionNumber) + String(answerOption)}
        disableAnswerButtons={props.disableAnswerButtons}
        answerNumber={answerOption}
        answerContent={props.answerOptions[answerOption].answer}
        answerType={props.answerOptions[answerOption].answer}
        userAnswers={props.userAnswers}
        userAnswersCorrect={props.userAnswersCorrect}
        subQuestionNumber={subQuestionNumber}
        onAnswerSelected={props.onAnswerSelected}
      />
    );
  }

  function renderSubQuestions(key,index) {
    return (
      <div className="subSection" key={'subsection_' + key.subQuestion}>
        <SubQuestion
          subQuestion={key.subQuestion}
        />
        <ul className="answerOptions">
          { renderAnswerOption(index, 0) }
          { renderAnswerOption(index, 1) }
          { renderAnswerOption(index, 2) }
        </ul>
      </div>
    );
  }

  return (
    <div>
      <img src={ logotagline } alt="" className="app-header-image" />
      <ReactCSSTransitionGroup
        className="container"
        component="div"
        transitionName="fade"
        transitionEnterTimeout={800}
        transitionLeaveTimeout={500}
        transitionAppear
        transitionAppearTimeout={500}
      >
        <div key={'question_' + props.questionNumber}>
          <QuestionIntro questionIntro={props.questionIntro} questionType={props.questionType} />
          <div className="subQuestions">
            {props.subQuestions.map( renderSubQuestions )}
          </div>
          <button className="continueButton" onClick={props.onClickContinue} disabled={props.disableContinue}>
            <span className="continueButton__text">{props.strings.questions.continue}</span>
          </button>
          <Credits strings={props.strings.credits} />
        </div>
      </ReactCSSTransitionGroup>
    </div>
  );
}

Quiz.propTypes = propTypes;

export default Quiz;



/** WEBPACK FOOTER **
 ** ./src/components/Quiz.js
 **/